import React, { useRef, useEffect, useState } from 'react';
import { SearchResultPlaceholder } from './searchResultPlaceholder';
import BarLoader from './BarLoader';
import styles from './BarStyles.module.css';
import UpIcon from './UpIcon';

const gradientMap = {
  "0": 'linear-gradient(180deg, rgba(226, 204, 242, 0.38) 0.17%, #E2CCF2 75.27%)',
  "1": 'linear-gradient(180deg, rgba(197, 153, 229, 0.38) 0.17%, #C599E5 75.27%)',
  "2": 'linear-gradient(180deg, rgba(168, 102, 216, 0.38) 0.17%, rgba(168, 102, 216, 0.94) 75.27%)',
  "3": 'linear-gradient(180deg, rgba(139, 51, 203, 0.38) 0.17%, rgba(139, 51, 203, 0.94) 75.27%)',
  "4": 'linear-gradient(180deg, rgba(88, 0, 152, 0.38) 0%, rgba(88, 0, 152, 0.94) 96.9%)',
};

const BarGraph = ({ height, width, loading = false, data = [], maxWidth='', barWidth = '' }) => {
  const [svgWidth, setSvgWidth] = useState(null);
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current) {
      const { width } = svgRef.current.getBoundingClientRect();
      setSvgWidth(width);
      console.log(`Width of the SVG: ${width}px`);
    }
  }, [data]);

  const max = Math.max(...data.map((point) => point.value)) || 1;

  if (loading) {
    return <div className={styles.loader_container}><BarLoader /></div>;
  }

  if (!data.length) {
    return (
      <div className={styles.placeholder_container}>
        <SearchResultPlaceholder text="No Data Found" iconType="lens" />
      </div>
    );
  }

  const ratioMultiplier = (height - 60) / max;

  return (
    <div
      className={styles.container}
      style={{
        fontFamily: "'Noto Sans', sans-serif", // Specify the font family
        height,
        width,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        position: 'relative',
        backgroundColor: '#FDF9FF',
      }}
    >
      {data.map((bar, index) => {
        const isLast = index === data.length - 1;
        const graphHeight = bar.value * ratioMultiplier;
        const nextBarHeight = isLast ? 0 : data[index + 1] ? data[index + 1].value * ratioMultiplier : 0;

        if (bar && bar.label === 'Inbound' && bar.value === 0) return null;

        return (
          <React.Fragment key={bar.label || index}>
            <div
              className={styles.bar_wrapper}
              style={{
                maxWidth: maxWidth,
                width:  barWidth, 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                borderLeft: index !== 0 ? '0.5px dashed var(--Border-Bold, #59566C)' : 'none',
                height: '100%',
              }}
            >
              <div
                style={{
                  textAlign: 'left',
                  height: '60px',
                  padding: '8px',
                }}
              >
                <div style={{ color: '#777584', marginBottom: '4px',fontSize:"10px",lineHeight:"14px",fontWeight:400}}>{bar.label || ''}</div>
                <div>
                  <span className={styles.count} style={{ color: '#2B244C',fontSize:"12px",lineHeight:"16px",fontWeight:500}}>{bar.value || 0}</span>
                  {bar.percentage !== undefined && bar.percentage !== null ? <span style={{ color: '#2B244C',fontSize:"10px",lineHeight:"14px",fontWeight:400}}>({bar.percentage}%)</span> : null}
                  {bar.unreadCount ? (
                    <span className={styles.unread}>
                      <div style={{ margin: '0 2px', display: 'inline' }}><UpIcon /></div>
                      {bar.unreadCount}
                    </span>
                  ) : null}
                </div>
              </div>
              <div
                className={styles.bar_container}
                style={{
                  height: `${height - 60}px`,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  width: '100%',
                  maxWidth: 128,
                }}
              >
                <div
                  className={styles.single_bar}
                  style={{
                    height: `${graphHeight}px`,
                    background: gradientMap[index % Object.keys(gradientMap).length],
                  }}
                ></div>
              </div>
            </div>
            {!isLast && (
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <svg
                  ref={index === 0 ? svgRef : null}
                  style={{
                    width: '100%',
                    height: `${height}px`,
                  }}
                >
                  <polygon
                    points={`${0},${height - graphHeight} ${svgWidth || 0},${height - nextBarHeight} ${svgWidth || 0},${height} ${0},${height}`}
                    fill="#E6EBEF"
                    stroke="none"
                  />
                </svg>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default BarGraph;
